import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { STORAGE } from '@shared/constants/storage.constants';
import { StorageService } from '@shared/services/storage/storage.service';
import { ASSET_MANAGEMENT_API, INVENTORY_MANAGEMENT, PRICING_API } from '@shared/constants/api.constants';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const accessToken = storageService.get(STORAGE.ACCESS_TOKEN);
  const excludeList: string[] = [
    INVENTORY_MANAGEMENT.UPLOAD, 
    INVENTORY_MANAGEMENT.EXPORT,
    ASSET_MANAGEMENT_API.VALIDATE_BULK_IMPORT, 
    PRICING_API.UPLOAD_CSV,
    ASSET_MANAGEMENT_API.CREATE_SINGLE_ASSET,
    ASSET_MANAGEMENT_API.UPDATE_ASSET,
  ];
  
  if (accessToken) {
    req = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + accessToken),
    });
  }

  if (!req.headers.has('Content-Type') && !excludeList.includes(req.url) && !(req.body instanceof FormData)) {
    req = req.clone({
      headers: req.headers.set('Content-Type', 'application/json'),
    });
  }
  return next(req);
};
